<template>
  <!--  -->
  <div id="app" v-loading="loading" :element-loading-text="$t('app.loading')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div v-if="$store.state.appInfo.site_state == 1">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.name" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" :key="$route.name" />
    </div>
    <div v-if="$store.state.appInfo.site_state == 0" style="box-sizing: border-box; padding: 30px; fong-size: 26px">{{ $store.state.appInfo.repair_tips }}</div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      daoTime: null,
      loading: false,
    };
  },
  created() {
    let that = this;
    console.log('版本代码更新时间 2022-10-13 14:30');
    var query = that.$route.query;

    let lang = localStorage.getItem('lang') || 'zh'; //没有就默认中文
    this.$i18n.locale = lang;
    localStorage.setItem('lang', lang);
    that.getApp();

    if (sessionStorage.getItem('token')) {
      that.openDaoTime();
      that.getUserInfo();
    }
    if (query.pid) {
      localStorage.setItem('pid', query.pid);
      that.$router.push({ path: '/register?pid=' + query.pid });
    }
    that.getVisitUrl();
  },
  methods: {
    // {{ $t('header.livevideo') }}
    getApp() {
      let that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code == 200) {
          // "ios_download_qrcode": "http://mb2.tg-demo.cc:86/uploads/images/e13177382b3e958789c877f71b034ca9.jpg",
          // "ios_download_url": "http://mb2.tg-demo.cc:86/",
          // "h5_url": "http://mb2m.tg-demo.cc"
          localStorage.setItem('appInfo', JSON.stringify(res.data));
          that.$store.commit('changappInfo');
          document.getElementsByTagName('title')[0].innerText = that.$store.state.appInfo.title;
        }
      });
    },
    outLogin() {
      let that = this;
      that
        .$confirm(that.$t('app.sure'), that.$t('app.hint'), {
          confirmButtonText: that.$t('app.Yes'),
          cancelButtonText: that.$t('app.No'),
          type: 'warning',
        })
        .then(() => {
          that.showLoading();
          that.$apiFun
            .post('/api/logoff', {})
            .then(res => {
              that.clearUser();
              that.hideLoading();

              that.$router.push({ path: '/' });
            })
            .catch(() => {
              that.clearUser();
              that.hideLoading();
              that.$router.push({ path: '/' });
            });
        })
        .catch(() => {});
    },
    clearUser() {
      let that = this;
      that.closeDaoTime();
      localStorage.clear();
      sessionStorage.clear();
      that.$store.commit('changUserInfo');
      that.$store.commit('changToken');
    },
    getVisitUrl() {
      let that = this;
      var query = that.$route.query;
      that.$apiFun
        .get('/api/getVisitUrl', {})
        .then(res => {
          if (res.code == 200) {
            let url = query.pid ? res.data.url + '?pid=' + query.pid : res.data.url;
            window.open(url, '_self');
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    closeDaoTime() {
      let that = this;
      if (that.daoTime != null) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    getBalance() {
      let that = this;
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          if (res.code == 401) {
            that.clearUser();

            that.$router.push({ path: '/' });
          }
        })
        .catch(res => {
          // console.log(res)
        });
    },
    openDaoTime() {
      let that = this;
      if (!that.daoTime) {
        that.daoTime = setInterval(() => {
          that.getBalance();
        }, 4300);
      }
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          let userInfo = res.data;
          if (userInfo.isblack == 1) {
            //黑名单

            that.clearUser();
            that.showTost(0, that.$t('login.blacklist'));

            return;
          }
          if (userInfo.status == 0) {
            //用户被禁用
            that.clearUser();
            that.showTost(0, that.$t('login.stop'));

            return;
          }
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          that.openDaoTime();
        }
      });
    },
    openKefu() {
      let that = this;
      that.showTost(1, that.$t('app.Linking'));
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          window.open(res.data.url);
        }
      });
    },
    showTost(type, title) {
      let str = type ? 'success' : 'warning';
      this.$message({
        message: title,
        type: str,
      });
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      let that = this;

      setTimeout(() => {
        that.loading = false;
      }, 500);
    },
    goNav(url) {
      let that = this;
      if (url == this.$route.fullPath) {
        that.showTost(0, that.$t('app.Already'));
        return;
      }
      if (url == '/app') {
        let routerData = this.$router.resolve({
          path: `/app`,
        });
        window.open(routerData.href, '_blank');

        return;
      }

      if (url == '/userredpacket') {
        if (!that.$store.state.token) {
          this.$router.push({ path: '/login' });
          return;
        }
        if (that.$store.state.appInfo.redpacket_switch == 0) {
          that.showTost(0, that.$t('app.Red'));
          return;
        }
        let routerData = this.$router.resolve({
          path: `/userredpacket`,
        });
        window.open(routerData.href, '_blank');

        return;
      }
      if (url == '/activity') {
        let routerData = this.$router.resolve({
          path: `/activity`,
        });
        window.open(routerData.href, '_blank');

        return;
      }

      if (url == '/recharge') {
        if (!that.$store.state.token) {
          this.$router.push({ path: '/login' });
          return;
        }
      }
      this.url = url;

      this.$router.push({ path: url });
    },
  },
  mounted() {},
};
</script>

<style>
/* 輪播 */
.swiper-pagination-bullet {
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 30px));
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 30px));
}
.van-swipe__indicators {
  bottom: 28px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__indicators {
  left: unset;
  transform: unset;
  right: 45%;
  bottom: 5%;
}
.el-carousel__button {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
}
.is-active .el-carousel__button {
  background: blue;
}
/* 加載中 */
.el-loading-mask {
  position: fixed;
}
/* 导航 */
#meyNav {
  cursor: pointer;
}

.header-logo {
  width: 100px !important;
  margin: -50px auto 0 auto;
  display: inherit;
}

.nav .subnav li[game-box='ob'] {
  background-image: url(/static/image/vendorGameLogoA1640062419.png);
  background-size: 100% 100%;
}
.index-page {
  position: relative;
  height: auto;
}
.msgBox__modal_CuorsterAreat_model__wwzuA .msgBox__flex__-7cOr {
  max-height: none !important;
  height: 540px !important;
  overflow: auto;
}
p {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
}
.msgBox__notice_header__kkFdX {
  background: -webkit-gradient(linear, left top, right top, from(#83a7ff), to(#4c4f54)) !important;
  background: linear-gradient(90deg, #858a97, #292d36) !important;
}
.main_container {
  background: none !important;
}
.right_content_layout {
  color: #fff !important;
}
.saving-tips .title {
  width: 200px !important;
}
.mt-tabpage-count {
  min-height: 863px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue